import React from 'react';

export type StatisticsSortType =
  | 'athAfCnt'
  | 'currentAfCnt'
  | 'athTokenAmountInDecimals'
  | 'currentTokenAmountInDecimals'
  | 'totalUsedUsd'
  | 'atlMc'
  | 'athMc'
  | 'lastFlowMc'
  | 'lastUpdated'
  | 'firstTransferAt'
  | 'firstTransferAtAsc'
  | 'tokenAmountRatio';

interface StatisticsSortSelectorProps {
  selectedType: StatisticsSortType;
  onTypeChange: (type: StatisticsSortType) => void;
}

const StatisticsSortSelector: React.FC<StatisticsSortSelectorProps> = ({
  selectedType,
  onTypeChange,
}) => {
  const sortTypes: { type: StatisticsSortType; label: string }[] = [
    { type: 'athAfCnt', label: 'ATH AF Count' },
    { type: 'currentAfCnt', label: 'Current AF Count' },
    { type: 'athTokenAmountInDecimals', label: 'ATH Token Amount' },
    { type: 'currentTokenAmountInDecimals', label: 'Current Token Amount' },
    { type: 'totalUsedUsd', label: 'Total Used USD' },
    { type: 'atlMc', label: 'ATL MC' },
    { type: 'athMc', label: 'ATH MC' },
    { type: 'lastFlowMc', label: 'Latest MC' },
    { type: 'lastUpdated', label: 'Latest TX' },
    { type: 'firstTransferAt', label: 'Latest Token Age' },
    { type: 'firstTransferAtAsc', label: 'Oldest Token Age' },
    { type: 'tokenAmountRatio', label: '% Token Holding (Current/ATH)' },
  ];

  return (
    <div className="flex items-center space-x-2">
      <label className="text-xs text-gray-400">Sort:</label>
      <select
        value={selectedType}
        onChange={(e) => onTypeChange(e.target.value as StatisticsSortType)}
        className="px-2 py-1 text-xs bg-gray-700 text-white border border-gray-600 rounded focus:outline-none focus:border-amber-500 transition-colors"
        style={{
          maxWidth: '150px'
        }}
      >
        {sortTypes.map(({ type, label }) => (
          <option key={type} value={type}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StatisticsSortSelector;
